var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 9.74479C9.44755 9.74479 8.91764 9.5253 8.52694 9.1346C8.13624 8.7439 7.91675 8.21399 7.91675 7.66146C7.91675 7.10892 8.13624 6.57902 8.52694 6.18832C8.91764 5.79762 9.44755 5.57812 10.0001 5.57812C10.5526 5.57812 11.0825 5.79762 11.4732 6.18832C11.8639 6.57902 12.0834 7.10892 12.0834 7.66146C12.0834 7.93505 12.0295 8.20595 11.9248 8.45872C11.8201 8.71148 11.6667 8.94114 11.4732 9.1346C11.2798 9.32805 11.0501 9.48151 10.7973 9.58621C10.5446 9.6909 10.2737 9.74479 10.0001 9.74479ZM10.0001 1.82812C8.45299 1.82812 6.96925 2.44271 5.87529 3.53667C4.78133 4.63063 4.16675 6.11436 4.16675 7.66146C4.16675 12.0365 10.0001 18.4948 10.0001 18.4948C10.0001 18.4948 15.8334 12.0365 15.8334 7.66146C15.8334 6.11436 15.2188 4.63063 14.1249 3.53667C13.0309 2.44271 11.5472 1.82813 10.0001 1.82812Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLocation);
export default __webpack_public_path__ + "static/media/footerLocation.6b1351ca98890d6acdabedc03928d792.svg";
export { ForwardRef as ReactComponent };